import dashboard from './dashboard';
// import pages from './pages';
// import utilities from './utilities';
// import other from './side_nav';
// import server from './server';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  // items: [dashboard, pages, utilities, other]
  // items: [dashboard, server, other]
  items: [dashboard]
};

export default menuItems;
